import React from "react";
import ChevronIcon from "../../Common/Svgs/ChevronIcon";

const CustomPagination = ({ current, type, originalElement, totalRecords }) => {
  const lastPage = totalRecords / current;

  if (type === "prev" && current === 0) {
    return (
      <button
        type="button"
        className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
        style={{
          pointerEvents: "none",
        }}
      >
        <ChevronIcon className="stroke-dark-gray" />
      </button>
    );
  }

  if (type === "prev" && current > 0) {
    return (
      <button
        type="button"
        className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
      >
        <ChevronIcon className="stroke-dark-gray" />
      </button>
    );
  }

  if (type === "next" && lastPage <= 10) {
    return (
      <button
        type="button"
        className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
        style={{ pointerEvents: "none" }}
      >
        <ChevronIcon className="stroke-dark-gray" />
      </button>
    );
  }

  if (type === "next") {
    return (
      <button
        type="button"
        className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
      >
        <ChevronIcon className="stroke-dark-gray" />
      </button>
    );
  }

  return originalElement;
};

export default CustomPagination;
